// import loadMoreFeaturePosts from '../components/loadMorePosts';
import gsap from 'gsap';
import pageFadeOut from '../components/pageFadeOut'
// import successPageAnimate from '../js/animate-in';
import animateInOnce from '../components/animateInOnce';

export default {
  init() {
    // JavaScript to be fired on the home page

    /*eslint-disable */
    // Controls fade out - on certain links
    let allAnchors = document.querySelectorAll('.featured-posts a, .footer-menu a');

    allAnchors.forEach(anchor => {
      anchor.addEventListener('click', pageFadeOut)
    })

    // Heading split text animation
    window.addEventListener('load', (e) => {
      console.log(e)


      if (document.body.classList.contains('featured')) {

        setTimeout( () => {
          gsap.to( '#bgFadeIn' , 0.4 , {
            opacity: 1,
            ease: 'power1.in'
          })

          setTimeout( () => {
            gsap.to( '.app-wrapper' , 0.5 , {
              opacity: 1,
              ease: 'power1.in',
            })
            animateInOnce('post-hero-title');
          },350);

        },0);

      }
    })


    let ajaxPosts = {
      posts: document.querySelector('#main-featured-posts-list'),
      button: document.querySelector('.load-more'),
      paged: Number(document.querySelector('#main-featured-posts-list').dataset.page),
      total: Number(document.querySelector('#main-featured-posts-list').dataset.total),
      url: 'action=featuredPosts&paged=',
    };

    ajaxPosts.button.addEventListener('click', startAjax);

    function startAjax() {
      event.preventDefault();

      let postsData = ajaxPosts.posts.dataset;

      // Get ajax posts
      // If there are posts left
      if (ajaxPosts.paged != Number(postsData.total)) {
        ajaxData(ajaxPosts.url + ajaxPosts.paged, 'POST');
      } else {
        // If no more posts
        // ajaxPosts.button.classList.add('hide-button')
        // return;
      }
    }

    function formatData(data) {
      let postData = data.more;
      let postsList = new Array();

      console.log('data',data)

      // Format new li
      for(let a = 0; a < postData.length; a++) {
        let li = document.createElement('li');
        li.classList.add('g-3', 'loading-in');
        li.setAttribute('id', 'post-' + postData[a].id);
        li.setAttribute('data-page', postData[a].page);

        let frameUrl = window.location.origin + '/app/themes/buzzworthy-fw/dist/images/post_bg_1x_a4b6a7be.png';
        // let frameUrl = window.location.origin + '/app/themes/buzzworthy-fw/dist/images/post_bg_1x.png';

        // Setup JSON to HTML
        /* eslint-disable */
        li.innerHTML =
        `<a href="${ postData[a].link }" class="absolute-link"></a>
        <figure>
            <img src="${ frameUrl }" alt="image border" class="border">
            <img
              srcset="${ postData[a].post_large[0] } 761w,
                    ${ postData[a].post_medium[0] } 400w"
                  src="${ postData[a].thumbnail[0] }"
                  alt="${ postData[a].alt }">
        </figure>
        <h3>
          <span>${ postData[a].title }</span>
        </h3>`;

        if (postData[a].subtitle !== null && postData[a].subtitle !== "") {
          li.innerHTML += `<p>${ postData[a].subtitle }</p>`;
        }
        // else if (postData[a].subtitle === '') {
        //   li.innerHTML += '';
        // }


        // if (postData[a].reading_time != null) {
        // // if ( postData[a].readting_time.isInteger(true)) {
        //   li.innerHTML += `<ul class="post-info a">
        //     <li>
        //         <p>${ postData[a].reading_time } min time</p>
        //       </li>
        //       <li>
        //         <p>
        //           <span class="tag">${ postData[a].cat[0].name }</span>
        //         </p>
        //     </li>
        //   </ul>`;
        // }
        // else {
          li.innerHTML +=`
          <ul class="post-info b">
            <li>
              <p>
                <span class="tag">${ postData[a].display_cat_name }</span>
              </p>
            </li>
          </ul`;

        // <span class="tag">${ postData[a].cat[0].name }</span>

        /* eslint-disable */
        postsList.push(li);
      }

      for(let b = 0; b < postsList.length; b++) {
        ajaxPosts.posts.appendChild(postsList[b]);
      }

      // Checks for new post to fade in
      if (document.querySelectorAll('li.loading-in') != undefined) {
        let newLi = ajaxPosts.posts.querySelectorAll('li.loading-in');

        // Fades in posts
        gsap.to(newLi , 0.4 , {
          opacity: 1,
          ease: 'power1.in',
          onComplete: function(e) {

            // Removes fade class
            newLi.forEach(li => {
              li.classList.remove('loading-in');
            })

            gsap.set(newLi, {clearProps: 'all'})

          }
        })
      }

       // Set total number of page posts
       ajaxPosts.posts.dataset.total = data.max_num_pages;

       // Increase current page
       if (data.max_num_pages > ajaxPosts.paged) {
         ajaxPosts.posts.dataset.page++;
         ajaxPosts.paged++;
       }

        // If total pages reached
        if (data.max_num_pages == ajaxPosts.paged) {
          console.log('format e;se')
          ajaxPosts.button.classList.add('hide-button')
        }
    }

// let ajaxInfo;

function ajaxData(url, type) {

  // Make request HTTPS
  let ajaxUrl = window.ajax_object.ajax_url;


  if (window.location.protocol == 'http:' && window.location.hostname != "newsette.bwsdemo.com") {
    ajaxUrl = ajaxUrl.split('http');
    ajaxUrl = 'https' + ajaxUrl[1];
  // ajaxUrl = 'http' + ajaxUrl[1];
  }

  let data;
  var xhr = new XMLHttpRequest();
  xhr.open(type, ajaxUrl, true);
  // xhr.open(type, "/wp/wp-admin/admin-ajax.php", true);
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
  xhr.onload = function () {
    if (this.status >= 200 && this.status < 400) {
      // If successful
      data = JSON.parse(this.response);
      if (data.post_count != 0) {
        formatData(data)
      }
    }
    else {
      // If fail
      data = JSON.parse(this.response);

      // eslint-disable-next-line
      console.log(data);
      ajaxInfo = data;
    }
  };

  // Connection error
  xhr.onerror = function () {
    // eslint-disable-next-line
    console.log(this);
  };
  if (url != '') {
    xhr.send(url);
    console.log('url', url)
  } else {
    xhr.send();
  }
}

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/featured.js